/* eslint-disable import/prefer-default-export */
import type { AsyncThunkPayloadCreator } from '@reduxjs/toolkit';
import createAxiosThunk from 'store/createAxiosThunk';
import type { RootState } from 'store/store';
import { coverageSnapshotSchema, type CoverageSnapshot } from 'schemas';

import * as selectAxios from '../config/selectAxios';
import * as selectFusion from '../../fusionServices/selectFusion';
import * as selectMemberPlan from './selectMemberPlan';
import * as selectFeatureFlags from '../config/selectFeatureFlags';

const payloadCreator: AsyncThunkPayloadCreator<CoverageSnapshot | null, void> = async (
  _args,
  thunkApi
) => {
  const { getState } = thunkApi;
  const state = getState();

  // If the Availity coverages configuration is not available on the network, return null and skip the api call
  const hasAvailityCoveragesConfiguration =
    selectFeatureFlags.hasAvailityCoveragesConfiguration(state);
  if (!hasAvailityCoveragesConfiguration) return null;

  const url = selectFusion.memberPlanUrl(state);
  const axios = selectAxios.axiosInstance(state);

  const response = await axios.get<unknown>(url);

  const coverageSnapshot = coverageSnapshotSchema.parse(response.data);
  return coverageSnapshot;
};

export const getMemberPlan = createAxiosThunk('getMemberPlan', payloadCreator, {
  // don't fetch the member plan if it's already been fetched or is currently being fetched
  // https://redux-toolkit.js.org/api/createAsyncThunk#canceling-before-execution
  condition: (_args: void, { getState }: { getState: () => RootState }): boolean => {
    const state = getState();
    const showServiceCost = selectFeatureFlags.showServiceCost(state);
    if (!showServiceCost) return false;

    const memberPlanComplete = selectMemberPlan.isComplete(state);
    const memberPlanLoading = selectMemberPlan.isLoading(state);
    return !memberPlanComplete && !memberPlanLoading;
  },
});
